import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-704b1338"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "inviteUser",
  tabindex: "-1",
  "data-bs-backdrop": "true",
  "aria-labelledby": "inviteUserLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content invite-modal" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "inviteUserLabel"
  }, "Mitarbeiter anlegen"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Schließen"
  })
], -1))
const _hoisted_5 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_6 = { class: "feedback success" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "feedback-icon" }, "✓", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "hint" }
const _hoisted_10 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_11 = { class: "feedback error" }
const _hoisted_12 = {
  key: 2,
  class: "modal-body"
}
const _hoisted_13 = { class: "form-grid" }
const _hoisted_14 = { class: "field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "invite-firstname" }, "Vorname", -1))
const _hoisted_16 = { class: "field" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "invite-lastname" }, "Nachname", -1))
const _hoisted_18 = { class: "field full" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "invite-email" }, "E-Mail-Adresse", -1))
const _hoisted_20 = {
  key: 0,
  class: "field full"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "invite-group" }, [
  /*#__PURE__*/_createTextVNode("Gruppe "),
  /*#__PURE__*/_createElementVNode("span", { class: "optional" }, "(optional)")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Keine Gruppe", -1))
const _hoisted_23 = ["label"]
const _hoisted_24 = ["value"]
const _hoisted_25 = ["value"]
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "field full" }
const _hoisted_28 = { class: "check-label" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "check-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "check-title" }, "Als Administrator anlegen"),
  /*#__PURE__*/_createElementVNode("span", { class: "check-hint" }, "Administratoren können Mitarbeiter verwalten, Kurse zuweisen und Einstellungen ändern.")
], -1))
const _hoisted_30 = { class: "field full" }
const _hoisted_31 = { class: "check-label" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "check-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "check-title" }, "Einladung per E-Mail senden"),
  /*#__PURE__*/_createElementVNode("span", { class: "check-hint" }, "Der Mitarbeiter erhält sofort eine E-Mail mit dem Link zur Plattform und meldet sich dort ohne Passwort mit seiner E-Mail-Adresse an.")
], -1))
const _hoisted_33 = { class: "field full consent-field" }
const _hoisted_34 = { class: "consent-label" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Einwilligung zur Datenverarbeitung liegt vor", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "consent-hint" }, " Wenn aktiviert, entfällt das Datenschutz-Modal beim ersten Login des Mitarbeiters. ", -1))
const _hoisted_37 = { class: "modal-footer" }
const _hoisted_38 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.success)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.savedName), 1),
                  _createTextVNode(" wurde erfolgreich angelegt."),
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.invitationSentTo
                ? `Eine Einladung mit dem Zugang zur Plattform wurde an ${_ctx.invitationSentTo} gesendet.`
                : 'Es wurde keine Einladung per E-Mail versendet.'), 1)
                ])
              ])
            ]))
          : (_ctx.errorMsg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.errorMsg), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _withDirectives(_createElementVNode("input", {
                      id: "invite-firstname",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstName) = $event)),
                      type: "text",
                      autocomplete: "given-name",
                      placeholder: "Erika",
                      required: "",
                      onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.firstName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _withDirectives(_createElementVNode("input", {
                      id: "invite-lastname",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lastName) = $event)),
                      type: "text",
                      autocomplete: "family-name",
                      placeholder: "Mustermann",
                      required: "",
                      onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.lastName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _withDirectives(_createElementVNode("input", {
                      id: "invite-email",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event)),
                      type: "email",
                      autocomplete: "email",
                      placeholder: "erika@einrichtung.de",
                      required: "",
                      onKeyup: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.email]
                    ])
                  ]),
                  (_ctx.flatGroupOptions.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _hoisted_21,
                        _withDirectives(_createElementVNode("select", {
                          id: "invite-group",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.groupId) = $event))
                        }, [
                          _hoisted_22,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupTree, (root) => {
                            return (_openBlock(), _createElementBlock("optgroup", {
                              key: root.groupId,
                              label: root.name
                            }, [
                              _createElementVNode("option", {
                                value: root.groupId
                              }, _toDisplayString(root.name), 9, _hoisted_24),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(root.children, (child) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: child.groupId
                                }, [
                                  _createElementVNode("option", {
                                    value: child.groupId
                                  }, "↳ " + _toDisplayString(child.name), 9, _hoisted_25),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.children, (grand) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: grand.groupId,
                                      value: grand.groupId
                                    }, "↳ ↳ " + _toDisplayString(grand.name), 9, _hoisted_26))
                                  }), 128))
                                ], 64))
                              }), 128))
                            ], 8, _hoisted_23))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.groupId]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("label", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isAdmin) = $event)),
                        class: "check-input"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.isAdmin]
                      ]),
                      _hoisted_29
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("label", _hoisted_31, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.sendInvitation) = $event)),
                        class: "check-input"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.sendInvitation]
                      ]),
                      _hoisted_32
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("label", _hoisted_34, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.consentGiven) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.consentGiven]
                      ]),
                      _hoisted_35
                    ]),
                    _hoisted_36
                  ])
                ])
              ])),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("button", {
            type: "button",
            class: "modal-btn secondary",
            "data-bs-dismiss": "modal",
            ref: "dismiss"
          }, _toDisplayString(_ctx.success || _ctx.errorMsg ? 'Schließen' : 'Abbrechen'), 513),
          (!_ctx.success && !_ctx.errorMsg)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "modal-btn primary",
                disabled: _ctx.loading || !_ctx.firstName || !_ctx.lastName || !_ctx.email,
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
              }, _toDisplayString(_ctx.loading ? 'Wird angelegt…' : 'Anlegen'), 9, _hoisted_38))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}